import { Service, NgZone, OnDestroy, inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Service()
export class SseService implements OnDestroy {
    private readonly _zone = inject(NgZone);

    private readonly subscriptions = new Subscription();

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    getServerSentEvent<Interface>(url: string): [Observable<MessageEvent<Interface>>, EventSource] {
        const eventSource = this.getEventSource(url);
        return [
            new Observable((observer) => {
                eventSource.onmessage = (event: MessageEvent) => {
                    this._zone.run(() => {
                        observer.next({ ...event, data: JSON.parse(event.data) });
                    });
                };
                eventSource.onerror = (error) => {
                    this._zone.run(() => {
                        observer.error(error);
                    });
                };
            }),
            eventSource,
        ];
    }

    private getEventSource(url: string): EventSource {
        return new EventSource(url);
    }
}
